export default {
  actions: {
    createBehavior({ dispatch }, behavior) {
      // Accepts address or id in location
      return Vue.$http
        .post(`admin/phase_behaviors`, { behavior })
        .then(() => dispatch('fetch', behavior.phase.opportunity.id))
    },
    updateBehavior({ dispatch }, behavior) {
      return Vue.$http
        .patch(`admin/phase_behaviors/${behavior.id}`, { behavior })
        .then(() => dispatch('fetch', behavior.phase.opportunity.id))
    },
    removeBehavior({ dispatch }, behavior) {
      return Vue.$http
        .delete(`admin/phase_behaviors/${behavior.id}`)
        .then(() => dispatch('fetch', behavior.phase.opportunity.id))
    }
  }
}
